// SiteFooter — WebFooter from web-screens.jsx.

const FOOTER_COLS = [
  {
    head: 'Discover',
    links: ['Flights', 'Hotels', 'Trip Builder', 'Deals', 'Destinations'],
  },
  {
    head: 'Account',
    links: ['Sign in', 'Create account', 'My Trips', 'Travellers', 'Loyalty'],
  },
  {
    head: 'Company',
    links: ['About', 'Careers', 'Blog', 'Press', 'Partners'],
  },
];

export function SiteFooter() {
  return (
    <footer style={{
      padding: '60px clamp(16px, 4vw, 64px) 40px',
      borderTop: '1px solid rgba(255,255,255,0.07)',
      marginTop: 40,
    }}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: 'clamp(24px, 4vw, 60px)',
        marginBottom: 48,
      }}>
        {/* Brand column */}
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
            <svg width="28" height="28" viewBox="0 0 32 32">
              <path d="M4 6l8 18 4-9 8 11" stroke="#E8441A" strokeWidth="2.6" strokeLinecap="round" fill="none" strokeLinejoin="round"/>
              <circle cx="26" cy="6" r="3" fill="#E8441A"/>
            </svg>
            <span style={{ fontFamily: '"Inter Variable", "Inter", system-ui, sans-serif', fontSize: 18, fontWeight: 700, letterSpacing: -0.5, color: '#F4F3F0' }}>
              global flyt<span style={{ color: '#E8441A' }}>.</span>
            </span>
          </div>
          <p style={{ fontFamily: '"Inter Variable", "Inter", system-ui, sans-serif', fontSize: 14, color: '#8C98B0', lineHeight: 1.6, maxWidth: 280 }}>
            One app for flights, stays, and the AI that does the spreadsheet for you. No fine-print theatre.
          </p>
          <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
            {['App Store', 'Google Play'].map(s => (
              <div key={s} style={{
                padding: '8px 14px', borderRadius: 10,
                border: '1px solid rgba(255,255,255,0.14)',
                fontFamily: '"Inter Variable", "Inter", system-ui, sans-serif',
                fontSize: 12, fontWeight: 600, color: '#F4F3F0',
                cursor: 'pointer',
              }}>{s}</div>
            ))}
          </div>
        </div>

        {/* Nav columns */}
        {FOOTER_COLS.map(col => (
          <div key={col.head}>
            <div style={{
              fontFamily: '"Inter Variable", "Inter", system-ui, sans-serif',
              fontSize: 11, letterSpacing: 2, fontWeight: 700,
              color: '#8C98B0', textTransform: 'uppercase', marginBottom: 16,
            }}>{col.head}</div>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 10 }}>
              {col.links.map(link => (
                <li key={link}>
                  <button style={{
                    background: 'none', border: 'none', padding: 0, cursor: 'pointer',
                    fontFamily: '"Inter Variable", "Inter", system-ui, sans-serif',
                    fontSize: 14, color: '#8C98B0', transition: 'color .15s',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = '#F4F3F0')}
                  onMouseLeave={(e) => (e.currentTarget.style.color = '#8C98B0')}
                  >
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Bottom bar */}
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        paddingTop: 24, borderTop: '1px solid rgba(255,255,255,0.07)',
      }}>
        <span style={{ fontFamily: '"Inter Variable", "Inter", system-ui, sans-serif', fontSize: 12, color: '#4E5E78' }}>
          © {new Date().getFullYear()} Global Flyt. India-first. PCI-SAQ-A.
        </span>
        <div style={{ display: 'flex', gap: 20 }}>
          {['Privacy', 'Terms', 'Cookie Policy'].map(l => (
            <button key={l} style={{
              background: 'none', border: 'none', cursor: 'pointer',
              fontFamily: '"Inter Variable", "Inter", system-ui, sans-serif',
              fontSize: 12, color: '#4E5E78', transition: 'color .15s',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = '#8C98B0')}
            onMouseLeave={(e) => (e.currentTarget.style.color = '#4E5E78')}
            >{l}</button>
          ))}
        </div>
      </div>
    </footer>
  );
}
